export default __webpack_public_path__ + "static/2-ff95ada0768e6c983f7cfc927b1cd6fc.png";